/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MehrarbeitUmbuchungDto } from '../../models/mehrarbeit-umbuchung-dto';

export interface GetAllMehrarbeitUmbuchungen$Plain$Params {
  date?: string;
  mitarbeiterId?: string;
}

export function getAllMehrarbeitUmbuchungen$Plain(http: HttpClient, rootUrl: string, params?: GetAllMehrarbeitUmbuchungen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MehrarbeitUmbuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMehrarbeitUmbuchungen$Plain.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MehrarbeitUmbuchungDto>>;
    })
  );
}

getAllMehrarbeitUmbuchungen$Plain.PATH = '/v1/mehrarbeitumbuchung';
